import { Element } from "@xmpp/xml"
import PubSubEventParser from "./PubSubEventParser"
import VCardParser from "@/lib/VCardParser"
import { Profile } from "@/reducers/profilesSlice"

class Parser {
  static readonly NODE = "urn:slickshift:account:users:0"
  static readonly NAMESPACE = "urn:slickshift:account:0"

  static parse(stanza: Element): Profile | undefined {
    const userElement = stanza?.getChild("user", this.NAMESPACE)

    if (!userElement) return

    const vCard = VCardParser.parse(userElement)

    if (!vCard) return

    const preferredLanguage =
      userElement.getChildText("preferredLanguage") || undefined

    const disabledEl = userElement.getChild("disabled", Parser.NAMESPACE)
    const disabled = disabledEl?.getText()?.toLowerCase() === "true"

    return {
      ...vCard,
      jid: stanza.getAttr("id"),
      ...(preferredLanguage && { preferredLanguage }),
      ...(disabled && { disabled: true }),
    }
  }
}

export const UserVcardPubSubParser = new PubSubEventParser<Profile>(
  Parser.parse,
  Parser.NODE,
)
